module.exports = __webpack_public_path__ + "img/ordinary_a.5f694786.png";